import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 8.913L7.625 5.81a2.25 2.25 0 012.25 0l4.25 2.455a2.254 2.254 0 002.25 0L21.75 5.16m-17 13.59a2.5 2.5 0 01-2.5-2.5v-3.87l5.375-3.103a2.25 2.25 0 012.25 0l4.25 2.453a2.245 2.245 0 002.25 0l4.25-2.453a.75.75 0 011.125.65v6.323a2.5 2.5 0 01-2.5 2.5H4.75z"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M2.25 8.913L7.625 5.81a2.25 2.25 0 012.25 0l4.25 2.455a2.254 2.254 0 002.25 0L21.75 5.16m-17 13.59a2.5 2.5 0 01-2.5-2.5v-3.87l5.375-3.103a2.25 2.25 0 012.25 0l4.25 2.453a2.245 2.245 0 002.25 0l4.25-2.453a.75.75 0 011.125.65v6.323a2.5 2.5 0 01-2.5 2.5H4.75z"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M4.5 17.826l10.75-6.208a4.5 4.5 0 014.5 0l8.5 4.91a4.509 4.509 0 004.5 0L43.5 10.32M9.5 37.5a5 5 0 01-5-5v-7.74l10.75-6.206a4.5 4.5 0 014.5 0l8.5 4.906a4.49 4.49 0 004.5 0l8.5-4.906c1-.578 2.25.146 2.25 1.3V32.5a5 5 0 01-5 5h-29z"
  }))
};
export var ElevationChange = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});